import React from "react"

import {FieldGraphTickLabelViewProps} from "../../../../render/graph-tick-label"
import Field_GraphTickLabelView from "../../../../proto/render/graph-tick-label"

// const debug = "FieldProjectType_GraphTickLabelView"
const debug = false

export default function FieldProjectType_GraphTickLabelView(props: FieldGraphTickLabelViewProps) {

    const value = props.field.getValue(props.model)
    let option = props.field._getOption(value)
    if (!option) { // if no value then set special field value
        option = {
            value   : 0,
            label   : props.field.noValueOptionLabel
        }
    }

    debug && console.log(debug, 'render', option, props)


    return (
        <Field_GraphTickLabelView {...props} hintName={option.label}>
            <div className="ui5-txt-default-small txt-truncate">{option.label}</div>
        </Field_GraphTickLabelView>
    )
}